import React, {useState, useEffect, useRef } from 'react';
import { json, useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios';
import '../../BusinessInfo/css/BusinessInfo.css';
import Building_img from '../img/Building.png';
import Development_img from '../../BusinessInfo/img/Development.png';
// import VR_img from '../img/VR.png';
import VR_img from '../../BusinessInfo/img/VR.jpg';
import QualityINSP_img from '../img/QualityINSP.png';
import design1 from '../img/sotec_img_design_1.png';
import design2 from '../img/sotec_img_design_2.png';
import design3 from '../img/sotec_img_design_3.png';
import Text from '../../../common/Text.js';


// import Dots from '../../BusinessInfo/Component/Dots.js';
import Building_test from '../../BusinessInfo/Component/Building_test.js';
import Develop from '../../BusinessInfo/Component/Develop.js';
import QualityINSP from '../../BusinessInfo/Component/QualityINSP.js';
import VR from '../../BusinessInfo/Component/VR.js';



// 사업소개 (리뉴얼) - 설계
function Building() {

    const location = useLocation();
    var data = location.state?.data;
    const [Color_B, setColor_B] = useState('black'); 
    const [Color_I, setColor_I] = useState('black'); 
    const [Color_Q, setColor_Q] = useState('black'); 
    const [Color_V, setColor_V] = useState('black'); 
    const [Bold_B, setBold_B] = useState('300'); 
    const [Bold_I, setBold_I] = useState('300'); 
    const [Bold_Q, setBold_Q] = useState('300'); 
    const [Bold_V, setBold_V] = useState('300'); 
    const [showButton, setShowButton] = useState(false);
    const [count, setcount] = useState(0);


    const sectionRef_B = useRef(null);
    const sectionRef_I = useRef(null);
    const sectionRef_Q = useRef(null);
    const sectionRef_V = useRef(null);

    // console.log('statestatestatestatestate!!!!!!!!!!!!');
    // console.log(data);



  useEffect(() => {



    scrollToSection(data);

    const options = {
        // null을 설정하거나 무엇도 설정하지 않으면 브라우저 viewport가 기준 .
        root: null,
        // 타겟 요소의 50%가 루트 요소와 겹치면 콜백을 실행
        threshold: 0.5

    };
       // Intersection Observer 인스턴스
        const observer = new IntersectionObserver(function (entries, observer) {
        
                if (entries[0].isIntersecting) {
                    entries[0].target.classList.add('testDiv_active');
                    console.log('Add active')
                    // console.log('Add active2222')
                    // console.log(data)
                    /* 설명 
                    scrollToSection('B');
                    : top기능 즉 맨위로 올리는 기능이 Layout.js에 있는데 맨위로 갈떄마다 smallmenu 옆 메뉴에 맨위의 메뉴인 설계에 포커싱이 안되서 
                      구간이 변경될떄마다 실행되는 설계 Intersection Observer에 로직 추가 
                     */

                      setColor_B('#0C4DA2');
            setColor_I('black');
            setColor_Q('black');
            setColor_V('black');
            setBold_B('bold');
            setBold_I('300');
            setBold_Q('300');
            setBold_V('300');
                }
                else {
                }
        }, options)


        const ims = document.querySelectorAll(".testgrp")

        ims.forEach(img => 
            observer.observe(img)
        );




        const observer2 = new IntersectionObserver(function (entries, observer) {
        
            entries.forEach(entry => {
              
                if (entries[0].isIntersecting) {
                    entries[0].target.classList.add('testDiv_active2');
                    console.log('Add active1')
                    setColor_I('#0C4DA2');
                    setColor_B('black');
                    setColor_Q('black');
                    setColor_V('black');
                    setBold_B('300');
                    setBold_I('bold');
                    setBold_Q('300'); 
                    setBold_V('300'); 
                }
                else {
                }
            })
        }, options)


        const ims2 = document.querySelectorAll(".testgrp2")

        ims2.forEach(img => 
            observer2.observe(img)
        );


        
        const observer3 = new IntersectionObserver(function (entries, observer) {
        
            if (entries[0].isIntersecting) {
                entries[0].target.classList.add('testDiv_active3');
                setColor_Q('#0C4DA2');
                setColor_B('black');
                setColor_I('black');
                setColor_V('black');
                setBold_B('300');
                setBold_I('300');
                setBold_Q('bold');
                setBold_V('300');
            }
            else {
            }
        }, options)


        const ims3 = document.querySelectorAll(".testgrp3")

        ims3.forEach(img => 
            observer3.observe(img)
        );


        
        
        const observer4 = new IntersectionObserver(function (entries, observer) {
        
            if (entries[0].isIntersecting) {
                entries[0].target.classList.add('testDiv_active4');
                setColor_Q('black');
                setColor_B('black');
                setColor_I('black');
                setColor_V('#0C4DA2');
                setBold_B('300');
                setBold_I('300');
                setBold_Q('300');
                setBold_V('bold');
            }
            else {
            }
        }, options)


        const ims4 = document.querySelectorAll(".testgrp4")

        ims4.forEach(img => 
            observer4.observe(img)
        );

        

        /*
        const handleShowButton = () => {
            if (window.scrollY > 750) {
                setShowButton(true)
            } else {
                setShowButton(false)
            }
        }

        console.log(window.scrollY)
        window.addEventListener("scroll", handleShowButton)
        return () => {
            window.removeEventListener("scroll", handleShowButton)
        }
*/

      }, [location])


      


      const scrollToSection = (pram) => {

        console.log(pram);
        if(pram === 'B')
        {
            console.log('설계');
            sectionRef_B.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setColor_B('#0C4DA2');
            setColor_I('black');
            setColor_Q('black');
            setColor_V('black');
            setBold_B('bold');
            setBold_I('300');
            setBold_Q('300');
            setBold_V('300');

            console.log(document.getElementsByClassName("txt_B").Text);
        } 
        else if(pram === 'I') 
        {
            console.log('시스템');
            sectionRef_I.current.scrollIntoView({ behavior: 'smooth', margin : '0 0 0 0' });
            setColor_I('#0C4DA2');
            setColor_B('black');
            setColor_Q('black');
            setBold_B('300');
            setBold_I('bold');
            setBold_Q('300'); 
            setColor_V('black');
            setBold_V('300');
            console.log(Color_I);
            console.log(Bold_I);
        }
        else if(pram === 'Q') 
        {
            console.log('품질품질');
            setColor_Q('#0C4DA2');
            setColor_B('black');
            setColor_I('black');
            setBold_B('300');
            setBold_I('300');
            setBold_Q('bold');
            setColor_V('black');
            setBold_V('300');
            sectionRef_Q.current.scrollIntoView({ behavior: 'smooth' });
        }
        else if(pram === 'V') 
        {
            setColor_Q('black');
            setColor_B('black');
            setColor_I('black');
            setColor_V('#0C4DA2');
            setBold_B('300');
            setBold_I('300');
            setBold_Q('300');
            setBold_V('bold');
            console.log(Color_V);
            console.log(Bold_V);
            sectionRef_V.current.scrollIntoView({ behavior: 'smooth' });
        }
      };




     return ( 
        <div class = 'groupall'>


            <div className='smallmenu' >
                <div className='smallmenuC'>
                    <div className='txt_B' num={1} style={{cursor : 'pointer', color : Color_B, fontWeight : Bold_B, margin : '5px 0 5px 0'}} onClick={() => scrollToSection('B')} >설계</div>
                    <div  style={{height : '1px', width : '120px' , backgroundColor: 'gray'}}/>
                    <div className='txt_I' num={2} style={{cursor : 'pointer', color : Color_I, fontWeight : Bold_I, margin : '5px 0 5px 0'}}  onClick={() => scrollToSection('I')}>시스템 개발</div>
                    <div  style={{height : '1px', width : '120px' , backgroundColor: 'gray'}}/>
                    <div className='txt_Q' num={3} style={{cursor : 'pointer', color : Color_Q, fontWeight : Bold_Q, margin : '5px 0 5px 0'}}  onClick={() => scrollToSection('Q')}>품질 검사</div>
                    <div  style={{height : '1px', width : '120px' , backgroundColor: 'gray'}}/>
                    <div className='txt_V' num={4} style={{cursor : 'pointer', color : Color_V, fontWeight : Bold_V, margin : '5px 0 5px 0'}}  onClick={() => scrollToSection('V')}>VR 교육 솔루션</div>
                </div>
            </div>
      
      
{/* 
            {showButton && (
                             <div className='Upclass' >
                             <div>
                             <div className='arrowUp' style={{color : 'white', fontSize : '25px', width : '50px', height : '27px',  margin : '1px 0 -1px 0'}}  onClick={() => scrollToSection('B')} >↑</div>
                             <div className='top' onClick={() => scrollToSection('B')} ></div>
                             <div className='top' onClick={() => scrollToSection('B')} >TOP</div>
                         </div>
                     </div> 
             
                        )} */}

       

      



            <div class = 'testgrp' ref={sectionRef_B}>
                
                <div class="imgtxt"> 
                    <img class="imgs_B"  src={Building_img} />
                    <Text variant='titlename' className='Title_B'>설계</Text>
                </div>

                <div class='test11'><Building_test ></Building_test></div> 

            </div>


            <div class = 'testgrp2'   ref={sectionRef_I}  >
                
                <div class="imgtxt" > 
                <Text variant='titlename' className='Title_B'>시스템 개발</Text>
                <img class="imgs_B"  src={Development_img} ></img>
                </div>

                <div class='test12'><Develop ></Develop></div>

            </div>

            
            <div class = 'testgrp3'  ref={sectionRef_Q}   >
            <div class="imgtxt"  > 
            <Text variant='titlename'  className='Title_B'>품질 검사</Text>
            <img class="imgs_B"  src={QualityINSP_img} ></img>
            </div>
                <div class='test13'><QualityINSP ></QualityINSP></div> 
            </div>


            <div class = 'testgrp4'  ref={sectionRef_V}   >
            <div class="imgtxt"  > 
            <Text variant='titlename'  className='Title_B'>VR 교육 솔루션</Text>
            <img class="imgs_B"  src={VR_img} ></img>
            </div>
                <div class='test14'><VR></VR></div> 
            </div>
            

        </div>
            
     );

     
 }
 
 export default Building;
